module.exports = __webpack_public_path__ + "static/media/robot.34df298e.png";